import { jsx as _jsx } from "react/jsx-runtime";
import { StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { Col, TextBody, TextLabel } from '../../atoms';
export function Tag({ label, large = false, rounded = false, variant = 'neutral', }) {
    const textProps = {
        em: true,
        style: $text[variant],
        lhFull: true,
    };
    const textEl = large ? (_jsx(TextBody, Object.assign({}, textProps, { small: true, children: label }))) : (_jsx(TextLabel, Object.assign({}, textProps, { children: label })));
    return (_jsx(Col.C, { style: [
            $container.default,
            large && $container.large,
            rounded && $container.rounded,
            $container[variant],
        ], children: textEl }));
}
const $container = StyleSheet.create({
    default: {
        borderRadius: theme.radius.sm,
        paddingHorizontal: theme.spacing['1.5'],
        height: 16,
    },
    large: {
        // Note: `padding` alone does not work, we need to override parent `default` padding-x
        paddingHorizontal: theme.spacing['2'],
        paddingVertical: theme.spacing['2'],
        height: 25,
    },
    rounded: {
        borderRadius: 999,
    },
    neutral: {
        backgroundColor: theme.color.background.secondary,
    },
    info: {
        backgroundColor: theme.color.background.info,
    },
    success: {
        backgroundColor: theme.color.background.success,
    },
});
const $text = StyleSheet.create({
    neutral: {
        color: theme.color.text.primary,
    },
    info: {
        color: theme.color.text.info,
    },
    success: {
        color: theme.color.text.success,
    },
});
